import {
  BOOKING_URL,
  BOOKING_DETAILS,
  BOOKING_LIST,
  BOOKING_STATUS,
  TICKET_QR_SCAN,
  EVENT_BOOKING_LIST,
  TICKET_DETAILS,
  MY_EVENTS,
  TICKET_GRANT_ACCESS,
  CHECK_TICKET_ID,
  GET_ALL_CLUSTERS,
  GET_ALL_VENUES,
  GET_ALL_FACILITIES,
  GET_TIME_SLOTS,
  GET_ALL_EXISITING_USERS,
  GET_ALL_STATES,
  GET_ALL_DISTRICTS_BY_STATE,
  BOOKING_USER,
  UPDATE_PAYMENT_STATUS,
  GET_BOOKING_DETAILS,
  CHECK_DUPLICATE_VALUES,
  GET_ALL_FACILITIES_NEW,
  VENUE_LIST_URL,
} from "../../../config/adminUrlConfig";

import axios from "axios";

// Venue list lives on the standalone venue service (REACT_APP_VENUE_BASE_URL),
// not the booking service — its CORS only allows Content-Type/Authorization/
// X-Requested-With, so plain axios with just Authorization, no Api-Version header.
export const getVenueList = ({ page, limit, cluster_id, search, is_assigned } = {}) => {
  const token = localStorage.getItem("access_token_admin");
  const venueBaseUrl = process.env.REACT_APP_VENUE_BASE_URL?.replace(/\/$/, "");
  return axios.get(`${venueBaseUrl}${VENUE_LIST_URL}`, {
    params: { page, limit, cluster_id, search, is_assigned },
    headers: {
      Authorization: `${token}`,
    },
  });
};
// const token = localStorage.getItem("access_token_admin")
// console.log(token, "token in venue")
export const venueManagerBookingUrl = (id) => {
  // alert(bookToken);
  const token = localStorage.getItem("access_token_admin");

  return axios.get(
    `${process.env.REACT_APP_BOOKING_URL}${BOOKING_URL}?booking_id=${id}`,
    {
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    },
  );
};

export const checkTicketById = (id) => {
  // alert(bookToken);
  const token = localStorage.getItem("access_token_admin");

  return axios.get(
    `${process.env.REACT_APP_TICKET_URL}${CHECK_TICKET_ID}/${id}`,
    {
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    },
  );
};

export const bookingDetailsUrl = (id) => {
  const token = localStorage.getItem("access_token_admin");
  return axios.get(
    `${process.env.REACT_APP_BOOKING_URL}${BOOKING_DETAILS}/${id}`,
    {
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    },
  );
};

export const TicketDetailsUrl = (id) => {
  const token = localStorage.getItem("access_token_admin");
  return axios.get(
    `${process.env.REACT_APP_TICKET_URL}${CHECK_TICKET_ID}/${id}`,
    {
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    },
  );
};

export const GrantAccess = (id) => {
  const token = localStorage.getItem("access_token_admin");

  return axios.patch(
    `${process.env.REACT_APP_TICKET_URL}${TICKET_GRANT_ACCESS(id)}`,
    {},
    {
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
    },
  );
};

export const fetchBookingList = async ({
  page,
  limit,
  venue,
  sport,
  status,
  search,
}) => {
  try {
    const token = localStorage.getItem("access_token_admin");
    const response = await axios.get(
      `${process.env.REACT_APP_BOOKING_URL}${BOOKING_LIST}`,
      {
        params: {
          page: page,
          limit: limit,
          venue_id: venue,
          sport_id: sport,
          search: search,
          status: status,
        },
        headers: {
          Authorization: `${token}`,
        },
      },
    );
    // console.log(response.data?.data,"==>")

    // Return data based on your API structure
    return response.data || [];
  } catch (error) {
    console.error("Error fetching bookings:", error);
    return [];
  }
};

export const fetchMyEventList = async ({
  page,
  limit,
  search,
  sportFilter,
  dateFilter,
  statusFilter,
  feeType,
  clusterFilter,
  venueFilter,
}) => {
  try {
    const token = localStorage.getItem("access_token_admin");
    const response = await axios.get(
      `${process.env.REACT_APP_TICKET_URL}${MY_EVENTS}`,
      {
        params: {
          page: page,
          limit: limit,
          search: search,
          event_type: sportFilter,
          start_date: dateFilter,
          is_active: statusFilter,
          fee_type: feeType,
          cluster: clusterFilter,
          venue: venueFilter,
        },
        headers: {
          Authorization: `${token}`,
        },
      },
    );

    // Return data based on your API structure
    return response.data || [];
  } catch (error) {
    console.error("Error fetching bookings:", error);
    return [];
  }
};

export const fetchEventBookingList = async ({
  page,
  limit,
  date,
  sport,
  status,
  search,
}) => {
  try {
    const token = localStorage.getItem("access_token_admin");
    const response = await axios.get(
      `${process.env.REACT_APP_TICKET_URL}${EVENT_BOOKING_LIST}`,
      {
        params: {
          page: page,
          limit: limit,
          start_date: date,
          sport_id: sport,
          search: search,
          booking_status: status,
        },
        headers: {
          Authorization: `${token}`,
        },
      },
    );
    // console.log(response.data?.data,"==>")

    // Return data based on your API structure
    return response.data || [];
  } catch (error) {
    console.error("Error fetching bookings:", error);
    return [];
  }
};

export const bookingStatus = (id, status, remark) => {
  const token = localStorage.getItem("access_token_admin");
  return axios.post(
    `${process.env.REACT_APP_BOOKING_URL}${BOOKING_STATUS}`,
    {
       id: id,
      status: status,
      remark: remark,
    },
    {
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    },
  );
};

// book for others apis

export const fetchAllClusters = () => {
  try {
    const token = localStorage.getItem("access_token_admin");
    return axios.get(
      `${process.env.REACT_APP_BOOKING_URL}${GET_ALL_CLUSTERS}?booking_for_user=1`,
      {
        headers: {
          Authorization: `${token}`,
          "Content-Type": "application/json",
        },
      },
    );
  } catch (error) {
    console.error("Error fetching bookings:", error);
    return error;
  }
};

export const fetchAllVenues = (id) => {
  try {
    const token = localStorage.getItem("access_token_admin");
    return axios.get(
      `${process.env.REACT_APP_BOOKING_URL}${GET_ALL_VENUES}/${id}?booking_for_user=1`,
      {
        headers: {
          Authorization: `${token}`,
          "Content-Type": "application/json",
        },
      },
    );
  } catch (error) {
    console.error("Error fetching venues:", error);
    return error;
  }
};

export const fetchAllFacilities = (id) => {
  try {
    const token = localStorage.getItem("access_token_admin");
    return axios.get(
      `${process.env.REACT_APP_BOOKING_URL}${GET_ALL_FACILITIES_NEW}/${id}?booking_for_user=1`,
      {
        headers: {
          Authorization: `${token}`,
          "Content-Type": "application/json",
        },
      },
    );
  } catch (error) {
    console.error("Error fetching facilities:", error);
    return error;
  }
};

export const fetchTimeSlots = (venueId, facilityId, zoneId, date) => {
  try {
    const token = localStorage.getItem("access_token_admin");
    return axios.get(`${process.env.REACT_APP_BOOKING_URL}${GET_TIME_SLOTS}`, {
      params: {
        venue_id: venueId,
        sport_id: facilityId,
        zone_id: zoneId,
        slot_date: date,
      },
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    });
  } catch (error) {
    console.error("Error fetching time slots:", error);
    return error;
  }
};

export const fetchExistingUsers = async (search) => {
  try {
    const token = localStorage.getItem("access_token_admin");

    const res = await axios.get(
      `${process.env.REACT_APP_BOOKING_URL}${GET_ALL_EXISITING_USERS}`,
      {
        params: { search },
        headers: {
          Authorization: `${token}`,
          "Content-Type": "application/json",
        },
      },
    );

    return res; // ✅ resolved response
  } catch (error) {
    console.error("Error fetching existing users:", error);
    throw error; // ✅ important
  }
};

export const checkDuplicateMobileNumber = async (mobile) => {
  try {
    const token = localStorage.getItem("access_token_admin");

    return axios.get(
      `${process.env.REACT_APP_BOOKING_URL}${CHECK_DUPLICATE_VALUES}`,
      {
        params: { mobile },
        headers: {
          Authorization: `${token}`,
          "Content-Type": "application/json",
        },
      },
    );
  } catch (error) {
    console.error("Error checking duplicate mobile number:", error);
    throw error;
  }
};

export const fetchAllStates = () => {
  try {
    const token = localStorage.getItem("access_token_admin");
    return axios.get(
      `
     ${process.env.REACT_APP_BOOKING_URL}${GET_ALL_STATES}`,
      {
        headers: {
          Authorization: `${token}`,
          "Content-Type": "application/json",
        },
      },
    );
  } catch (error) {
    console.error("Error fetching states:", error);
    return error;
  }
};

export const fetchAllDistrictsByState = (stateId) => {
  try {
    const token = localStorage.getItem("access_token_admin");
    return axios.get(
      `${process.env.REACT_APP_BOOKING_URL}${GET_ALL_DISTRICTS_BY_STATE}/${stateId}`,
      {
        headers: {
          Authorization: `${token}`,
          "Content-Type": "application/json",
        },
      },
    );
  } catch (error) {
    console.error("Error fetching districts:", error);
    return error;
  }
};

export const bookVenueSlot = (bookingData) => {
  try {
    const token = localStorage.getItem("access_token_admin");
    return axios.post(
      `${process.env.REACT_APP_BOOKING_URL}${BOOKING_USER}`,
      bookingData,
      {
        headers: {
          Authorization: `${token}`,
          "Content-Type": "application/json",
        },
      },
    );
  } catch (error) {
    console.error("Error booking venue slot:", error);
    return error;
  }
};

export const updatePayment = (paymentData) => {
  try {
    const token = localStorage.getItem("access_token_admin");
    return axios.post(
      `${process.env.REACT_APP_BOOKING_URL}${UPDATE_PAYMENT_STATUS}`,
      paymentData,
      {
        headers: {
          Authorization: `${token}`,
          "Content-Type": "application/json",
        },
      },
    );
  } catch (error) {
    console.error("Error updating payment status:", error);
    return error;
  }
};

export const getBookingDetails = (bookingId) => {
  try {
    const token = localStorage.getItem("access_token_admin");
    return axios.get(
      `${process.env.REACT_APP_BOOKING_URL}${GET_BOOKING_DETAILS}/${bookingId}`,
      {
        headers: {
          Authorization: `${token}`,
          "Content-Type": "application/json",
        },
      },
    );
  } catch (error) {
    console.error("Error fetching booking details:", error);
    return error;
  }
};
